import { SnapSiteConfigEditContext } from '@ui/features/snap-site-config/screens/edit/context';
import { useContext } from 'react';

export function useSnapSiteConfigEditContext() {
  const context = useContext(SnapSiteConfigEditContext);

  if (!context) {
    throw new Error(
      'useSnapSiteConfigEditContext must be used within a SnapSiteConfigEditContext.Provider',
    );
  }

  return context;
}
